export const TitulosServicos = [
  {servico: "Publicação no jornal", titulo: "Publique no Diário Oficial de Minas Gerais: Oficialidade e Tradição"},
  {servico: "Consulta ao acervo do jornal", titulo: "Descubra como consultar o Diário Oficial de forma fácil e gratuita"},
  {servico: "Ressarcimento de Valores", titulo: "Saiba como solicitar o ressarcimento de valores pagos relacionados ao serviço de publicação no Diário Oficial"},
  {servico: "Gratuidade de Publicação", titulo: "Entenda como solicitar gratuidade para publicações no Diário Oficial"}
] as {servico: string, titulo: string}[]
